import * as yup from 'yup';
import type { AnyObject } from 'yup';
import type { FormCheckboxProps } from '@gov-nx/ui/types/forms/FormCheckbox';

interface FieldProps {
	name: string;
	label: string;
	defaultValue?: boolean;
	isDisabled?: boolean;
	// isRequired?: boolean;
	oneOf?: { value: boolean[]; errorMessage: string };
}

export type CheckboxDefinition = {
	schema: yup.BooleanSchema<
		boolean | undefined,
		AnyObject,
		boolean | undefined
	>;
	defaultValue: boolean;
	field: FormCheckboxProps;
};
export const getCheckboxDefinition = (
	props: FieldProps
): CheckboxDefinition => {
	let schema = yup.boolean();

	if (props.oneOf) {
		schema = schema
			.required()
			.oneOf(props.oneOf.value, props.oneOf.errorMessage);
	}

	return {
		schema,
		defaultValue: props.defaultValue ?? false,
		field: {
			field: {
				size: 'm',
				name: props.name,
				isDisabled: props.isDisabled,
				// isRequired: props.isRequired,

				label: {
					children: props.label,
				},
			},
		},
	};
};
